import { render, staticRenderFns } from "./MonitUnit.vue?vue&type=template&id=2684879f&scoped=true&"
import script from "./MonitUnit.vue?vue&type=script&lang=js&"
export * from "./MonitUnit.vue?vue&type=script&lang=js&"
import style0 from "./MonitUnit.vue?vue&type=style&index=0&id=2684879f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684879f",
  null
  
)

export default component.exports